import React from "react"
import { useTranslation } from "react-i18next"

import { DataGridToolbar } from "@/nzds/data-grid"
import { useDownloadBillsExport } from "@/services/bill/use-download-bills-export"

import { MenuItem } from "@mui/material"
import type { GridSlots, PropsFromSlot } from "@mui/x-data-grid-pro"

interface AdminBillsGridToolbarProps extends PropsFromSlot<
  GridSlots["toolbar"]
> {
  canDownload: boolean
  csvDownloadHref?: string
  excelDownloadHref?: string
  isRecordCountLoading?: boolean
  recordCount?: number
}

const startBillsExport = (
  exportFile: (href: string) => void,
  href: string | undefined
): void => {
  if (!href) {
    return
  }

  exportFile(href)
}

export const AdminBillsGridToolbar: React.FC<AdminBillsGridToolbarProps> = ({
  canDownload,
  csvDownloadHref,
  excelDownloadHref,
  isRecordCountLoading,
  recordCount,
}) => {
  const { t } = useTranslation("common")
  const { billsExportIsPending, billsExportMutate } = useDownloadBillsExport()
  const isExportDisabled = !canDownload || billsExportIsPending

  return (
    <DataGridToolbar
      isMoreMenuDisabled={!canDownload}
      isMoreMenuLoading={billsExportIsPending}
      isRecordCountLoading={isRecordCountLoading}
      moreMenuItems={[
        <MenuItem
          key="export-csv"
          component="button"
          disabled={isExportDisabled}
          onClick={() => {
            startBillsExport(billsExportMutate, csvDownloadHref)
          }}
        >
          {t("menuItem.exportCsv")}
        </MenuItem>,
        <MenuItem
          key="export-excel"
          component="button"
          disabled={isExportDisabled}
          onClick={() => {
            startBillsExport(billsExportMutate, excelDownloadHref)
          }}
        >
          {t("menuItem.exportExcel")}
        </MenuItem>,
      ]}
      recordCount={recordCount}
      showFilters
    />
  )
}
